"use strict";
// Generated by robots, do not change this manually!
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2c = void 0;
exports.b2c = {
    ":root": {
        "--plasma-typo-display1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-display1-font-weight": "500",
        "--plasma-typo-display1-font-style": "normal",
        "--plasma-typo-display1-font-size": "6rem",
        "--plasma-typo-display1-letter-spacing": "-0.0190em",
        "--plasma-typo-display1-line-height": "6rem",
        "--plasma-typo-display2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-display2-font-weight": "500",
        "--plasma-typo-display2-font-style": "normal",
        "--plasma-typo-display2-font-size": "3.75rem",
        "--plasma-typo-display2-letter-spacing": "-0.0190em",
        "--plasma-typo-display2-line-height": "4rem",
        "--plasma-typo-display3-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-display3-font-weight": "500",
        "--plasma-typo-display3-font-style": "normal",
        "--plasma-typo-display3-font-size": "3rem",
        "--plasma-typo-display3-letter-spacing": "normal",
        "--plasma-typo-display3-line-height": "3.25rem",
        "--plasma-typo-headline1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-headline1-font-weight": "700",
        "--plasma-typo-headline1-font-style": "normal",
        "--plasma-typo-headline1-font-size": "2rem",
        "--plasma-typo-headline1-letter-spacing": "-0.0110em",
        "--plasma-typo-headline1-line-height": "2.25rem",
        "--plasma-typo-headline2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-headline2-font-weight": "600",
        "--plasma-typo-headline2-font-style": "normal",
        "--plasma-typo-headline2-font-size": "1.5rem",
        "--plasma-typo-headline2-letter-spacing": "-0.0220em",
        "--plasma-typo-headline2-line-height": "1.75rem",
        "--plasma-typo-headline3-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-headline3-font-weight": "600",
        "--plasma-typo-headline3-font-style": "normal",
        "--plasma-typo-headline3-font-size": "1.25rem",
        "--plasma-typo-headline3-letter-spacing": "-0.0250em",
        "--plasma-typo-headline3-line-height": "1.5rem",
        "--plasma-typo-headline4-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-headline4-font-weight": "700",
        "--plasma-typo-headline4-font-style": "normal",
        "--plasma-typo-headline4-font-size": "1.25rem",
        "--plasma-typo-headline4-letter-spacing": "-0.0250em",
        "--plasma-typo-headline4-line-height": "1.5rem",
        "--plasma-typo-body1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-body1-font-weight": "500",
        "--plasma-typo-body1-font-style": "normal",
        "--plasma-typo-body1-font-size": "1rem",
        "--plasma-typo-body1-letter-spacing": "-0.0190em",
        "--plasma-typo-body1-line-height": "1.25rem",
        "--plasma-typo-body2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-body2-font-weight": "600",
        "--plasma-typo-body2-font-style": "normal",
        "--plasma-typo-body2-font-size": "1rem",
        "--plasma-typo-body2-letter-spacing": "-0.0190em",
        "--plasma-typo-body2-line-height": "1.25rem",
        "--plasma-typo-body3-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-body3-font-weight": "700",
        "--plasma-typo-body3-font-style": "normal",
        "--plasma-typo-body3-font-size": "1rem",
        "--plasma-typo-body3-letter-spacing": "-0.0190em",
        "--plasma-typo-body3-line-height": "1.25rem",
        "--plasma-typo-paragraph1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-paragraph1-font-weight": "400",
        "--plasma-typo-paragraph1-font-style": "normal",
        "--plasma-typo-paragraph1-font-size": "1rem",
        "--plasma-typo-paragraph1-letter-spacing": "-0.0190em",
        "--plasma-typo-paragraph1-line-height": "1.375rem",
        "--plasma-typo-paragraph2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-paragraph2-font-weight": "600",
        "--plasma-typo-paragraph2-font-style": "normal",
        "--plasma-typo-paragraph2-font-size": "1rem",
        "--plasma-typo-paragraph2-letter-spacing": "-0.0190em",
        "--plasma-typo-paragraph2-line-height": "1.375rem",
        "--plasma-typo-footnote1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-footnote1-font-weight": "500",
        "--plasma-typo-footnote1-font-style": "normal",
        "--plasma-typo-footnote1-font-size": "0.875rem",
        "--plasma-typo-footnote1-letter-spacing": "-0.0190em",
        "--plasma-typo-footnote1-line-height": "1.125rem",
        "--plasma-typo-footnote2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-footnote2-font-weight": "600",
        "--plasma-typo-footnote2-font-style": "normal",
        "--plasma-typo-footnote2-font-size": "0.875rem",
        "--plasma-typo-footnote2-letter-spacing": "-0.0190em",
        "--plasma-typo-footnote2-line-height": "1.125rem",
        "--plasma-typo-button1-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-button1-font-weight": "600",
        "--plasma-typo-button1-font-style": "normal",
        "--plasma-typo-button1-font-size": "1rem",
        "--plasma-typo-button1-letter-spacing": "normal",
        "--plasma-typo-button1-line-height": "1.25rem",
        "--plasma-typo-button2-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-button2-font-weight": "600",
        "--plasma-typo-button2-font-style": "normal",
        "--plasma-typo-button2-font-size": "0.875rem",
        "--plasma-typo-button2-letter-spacing": "normal",
        "--plasma-typo-button2-line-height": "1rem",
        "--plasma-typo-caption-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-caption-font-weight": "500",
        "--plasma-typo-caption-font-style": "normal",
        "--plasma-typo-caption-font-size": "0.75rem",
        "--plasma-typo-caption-letter-spacing": "-0.0220em",
        "--plasma-typo-caption-line-height": "1rem",
        "--plasma-typo-underline-font-family": "\"SB Sans Text\",sans-serif",
        "--plasma-typo-underline-font-weight": "500",
        "--plasma-typo-underline-font-style": "normal",
        "--plasma-typo-underline-font-size": "0.625rem",
        "--plasma-typo-underline-letter-spacing": "0.0125em",
        "--plasma-typo-underline-line-height": "0.75rem",
        "--plasma-typo-overflow-wrap": "break-word",
        "--plasma-typo-hyphens": "auto",
        "fontSize": "16px"
    }
};
//# sourceMappingURL=b2c.js.map